module.exports = __webpack_public_path__ + "static/img/home-hero-mobile-bg-04.e3d6ed8.png";